import { parseNonNegativeDecimalInput } from "utils/input.normalize.logic";

/**
 * Parses hourly rate input as a non-negative decimal.
 * Keeps previous value when input is empty or not parseable.
 */
export const parseGigHourlyRateInput = (
  value: string,
  fallbackValue: number,
): number => {
  if (value.trim() === "") {
    return fallbackValue;
  }

  const normalizedValue = value.replace(",", ".");
  const parsedValue = parseNonNegativeDecimalInput(normalizedValue);
  return Number.isFinite(parsedValue) ? parsedValue : fallbackValue;
};
